import {useTranslation} from 'react-i18next';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/form';
import {ToggleGroup, ToggleGroupItem} from '@/components/ui/toggle-group';

import type {ExportOptionsFieldsProps} from '../../types/exportTypes';
import type {MedicationsOptions} from '../../utils/definitions/medicationsExport';
import {
  MEDICATION_SCOPES,
  medicationScopes,
} from '../../utils/definitions/medicationsExport';
import ResidentOptionsFields from './ResidentOptionsFields';

const MedicationsOptionsFields = ({
  form,
}: ExportOptionsFieldsProps<MedicationsOptions>) => {
  const {t} = useTranslation();

  return (
    <>
      <ResidentOptionsFields form={form} />
      <FormField
        control={form.control}
        name="options.scope"
        render={({field}) => (
          <FormItem>
            <FormLabel>{t('Medications')}</FormLabel>
            <FormControl>
              <ToggleGroup
                type="single"
                value={field.value}
                onValueChange={value => {
                  if (value) field.onChange(value);
                }}
              >
                {MEDICATION_SCOPES.map(scope => (
                  <ToggleGroupItem key={scope} value={scope}>
                    {medicationScopes[scope]}
                  </ToggleGroupItem>
                ))}
              </ToggleGroup>
            </FormControl>
          </FormItem>
        )}
      />
    </>
  );
};

export default MedicationsOptionsFields;
